import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "ÄŒasovov",
  "description": "",
  "published": "2006-06-26T00:00:00.000Z",
  "redirect_from": ["/blog/asovov/swizec/401"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Tole je bila zelo dolga novica, vendar pa ker je FireFox izredno neumen in je popacal session je stran izjavila, da nisem administrator in pojedla celoten tekst. ÄŒe se vam bere, ga imate v anglešÄini ... kdorkoli pa izdeluje FF naj se gre impalat (kdor ne ve kaj to pomeni naj si na wikipedii pogleda kaj je Vlad Tepes delal s svojimi jetniki)`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      